export default __webpack_public_path__ + "static/media/gameMusic.a2579fef.mp3";